// extracted by mini-css-extract-plugin
module.exports = {"matches-list-narrowed-icon":"_1Ny6350rlkQ34BqJeXj6","groups-select":"_3FjbKy9-1K2NnCKzU029"};